
interface LoaderProps {
    active: boolean;
}

export default function GenericLoader({active}: LoaderProps) {
  return (
    <div
          className="fixed top-0 left-0 right-0 bottom-0 z-50 bg-black opacity-50 flex justify-center items-center"
        >
          <div className="animate-spin rounded-full border-b-2 border-white w-10 h-10"></div>
        </div>
  )
}
